/**
 *  Show mobile menu, triggered by burger menu
 */
function playmakersMobileShowMenu() {
  // Show the navigation
  var x = document.getElementById('nav-primary');
  if (x.offsetParent === null) {
    x.style.setProperty('display', 'flex');
  } else {
    x.style.setProperty('display', 'none');
  }

  playmakersToggleExpandedMenu();
  playmakersSwitchMenuLogo();
}

/**
 *  Show mobile menu, triggered by burger menu
 */
function playmakersClickToplevelMenusWithSubmenus() {
  // When clicking top level menu in desktop, show big menu
  if (screen.width > 991) {
    playmakersToggleExpandedMenu();
    playmakersSwitchMenuLogo();
    playmakersToggleSubMenus();
    playmakersToggleSeperators();
  } else {
    // Mobile - submenus are always visible via CSS, no toggle needed
  }
}

/**
 *  Switch menu logo
 */
function playmakersSwitchMenuLogo() {
  var normalLogo = document.getElementById('menu-full-logo');
  var bigLogo = document.getElementById('menu-big-logo');
  if (normalLogo.offsetParent === null) {
    normalLogo.style.display = 'block';
    bigLogo.style.display = 'none';
  } else {
    normalLogo.style.display = 'none';
    bigLogo.style.display = 'block';
  }
}

/**
 *  Toggle the submenus
 */
function playmakersToggleSubMenus() {
  var classSubMenuSelector = '#nav-primary .submenu';
  let subMenus = document.querySelectorAll(classSubMenuSelector);
  for (var i = 0; i < subMenus.length; i++) {
    subMenus[i].classList.toggle('show-submenu');
  }

  // Toggle the arrows
  var classArrowsSelector = '#nav-primary .foldicon';
  let arrowsSelector = document.querySelectorAll(classArrowsSelector);
  for (var i = 0; i < arrowsSelector.length; i++) {
    arrowsSelector[i].classList.toggle('showicon');
  }
}

/**
 *  Toggle expanded menu
 */
function playmakersToggleExpandedMenu() {
  // Set the container with a proper class, so it shows properly when folded out
  var containerElement = document.getElementById('header-container');
  containerElement.classList.toggle('menu-overflow');
}

/**
 *  Toggle the seperators
 */
function playmakersToggleSeperators() {
  var classSeperatorSelector = '#nav-primary .seperator';
  let seperators = document.querySelectorAll(classSeperatorSelector);
  for (var i = 0; i < seperators.length; i++) {
    seperators[i].classList.toggle('show-seperator');
  }
}

/**
 *  Attach click event to location we want thing to change for menu
 */
(function() {
  /**
   *  Mobile burger menu
   */
  let mobileMenuElement = document.getElementById('mobilenav');
  if (mobileMenuElement) {
    mobileMenuElement.addEventListener('click', function() {
      playmakersMobileShowMenu();
    });
  }

  /**
   * Top level menus trigger foldout of menu
   */
  let topLevelTriggerElements = document.querySelectorAll(
    '#nav-primary .menu-has-submenu'
  );
  for (var i = 0; i < topLevelTriggerElements.length; i++) {
    topLevelTriggerElements[i].addEventListener('click', function(event) {
      // Handle clicks on top level menu that has submenues
      playmakersClickToplevelMenusWithSubmenus();
    });
  }
})();
